export const licensing = {
    restrict: [],
    visible: false,
    getLicenceAfterPostAuthentication: false,
};